import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS_SECURITY: MijnRoute = {
    path: 'veiligheids-berichten',
    navigationEvent: 'toAlertsSecurity',
    regex: /^\/zelf-regelen\/notificaties-beheren\/veiligheids-berichten$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent',
    internalPath: '/veiligheids-berichten'
};
